(() => {
  if (customElements.get('black-box-size-links')) return;

  class BlackBoxSizeLinks extends HTMLElement {
    connectedCallback() {
      if (this.dataset.counts !== 'true' || !this.dataset.collectionUrl) return;
      this.controller = new AbortController();
      this.loadCounts(this.controller.signal);
    }

    disconnectedCallback() {
      this.controller?.abort();
    }

    async loadCounts(signal) {
      try {
        const url = new URL(this.dataset.collectionUrl, window.location.origin);
        url.searchParams.set('filter.v.availability', '1');
        url.searchParams.set('section_id', 'black-box-size-counts');
        // Keep the preview theme when the collection URL is requested from a theme preview.
        const preview = new URLSearchParams(window.location.search).get('preview_theme_id');
        if (preview) url.searchParams.set('preview_theme_id', preview);
        const response = await fetch(url, { signal, credentials: 'same-origin' });
        if (!response.ok) throw new Error(`Stock data request returned ${response.status}`);
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        const payload = html.querySelector('[data-black-box-counts]');
        if (!payload) throw new Error('Stock data section is missing from this theme');
        const data = JSON.parse(payload.textContent);
        const filter = data.filters.find(item => item.parameter === this.dataset.filter);
        if (!filter || !data.in_stock_filter_active) {
          throw new Error('Enable Size and Availability filters for the selected sale collection in Shopify Search & Discovery');
        }
        if (!this.isConnected) return;
        this.querySelectorAll('[data-size]').forEach(tile => {
          const count = tile.querySelector('[data-size-count]');
          if (!count) return;
          const value = filter.values.find(item => String(item.value) === tile.dataset.size);
          count.textContent = `${value?.count ?? 0} ${this.dataset.suffix}`;
          count.hidden = false;
        });
      } catch (error) {
        if (error.name === 'AbortError') return;
        console.error('Black Box size counts unavailable', { collection: this.dataset.collectionUrl, cause: error.message });
        this.querySelectorAll('[data-size-count]').forEach(count => { count.hidden = true; });
        const notice = this.querySelector('[data-count-error]');
        notice.textContent = this.dataset.editor === 'true'
          ? `Live size counts unavailable: ${error.message}. Size links still work.`
          : 'Live stock counts are unavailable. Choose a size to see available styles.';
        notice.className = this.dataset.editor === 'true' ? 'black-box__editor' : 'black-box__meta';
        notice.hidden = false;
      }
    }
  }

  customElements.define('black-box-size-links', BlackBoxSizeLinks);
})();
